/**
 * NavDot — the single notification primitive for the nav. Generalizes the
 * receipt-branch dot (`bg-primary animate-pulse`) so every domain, row, and the
 * bell share ONE implementation:
 *   - count > 0  → a pill count badge (used on panel rows)
 *   - count == 0 → a plain dot (used as a roll-up on domain triggers / the bell)
 * Positioning is left to the caller via `className` (e.g. absolute placement).
 */
import React from 'react';

export interface NavDotProps {
  count?: number;
  pulse?: boolean;
  className?: string;
  title?: string;
}

export const NavDot: React.FC<NavDotProps> = ({ count, pulse = false, className = '', title }) => {
  if (count && count > 0) {
    return (
      <span
        title={title}
        className={`inline-flex items-center justify-center min-w-[16px] h-4 px-1 rounded-full bg-primary text-[#1a140a] text-[10px] font-semibold leading-none tabular-nums ${className}`}
      >
        {count > 99 ? '99+' : count}
      </span>
    );
  }
  return (
    <span
      title={title}
      className={`block w-[7px] h-[7px] rounded-full bg-primary ${pulse ? 'animate-pulse motion-reduce:animate-none' : ''} ${className}`}
    />
  );
};

export default NavDot;
